import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { IdCardsService } from "./idcards.service";
import * as dayjs from "dayjs";
import * as FileSaver from 'file-saver';
import { AlertasSwalService } from "src/app/services/alerts.service";

@Component({
  selector: "app-idcards",
  templateUrl: "./idcards.component.html",
  styles: [],
})
export class IdCardsComponent implements OnInit {
  realdata: any[] = [];
  listToSend: any[] = [];
  filterListToSend: any[] = [];
  listToPrint: any[] = [];
  filterListToPrint: any[] = [];

  currentSelectionToAdd: any[] = [];
  currentSelectionToRemove: any[] = [];

  dateInit: Date = undefined;
  dateEnd: Date = undefined;
  idtosend: string[] = [];

  public _filterToShow = "";
  public _filterToPrint = "";
  today: Date;
  constructor(
    public service: IdCardsService,
    public spinner: NgxSpinnerService,
    private alerts: AlertasSwalService
  ) {}
  ngOnInit(): void {
    this.today = new Date();
    this.loadRecords();
  }

  loadRecords() {
    this.service.getWorkers().subscribe(
      (resultData) => {
        this.idtosend = [];
        this.currentSelectionToAdd = [];
        this.currentSelectionToRemove = [];
        this.realdata = resultData;
        this.changeRealData();
        this.filterdata();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  filterdata() {
    let filterdata = this.listToSend;
    let filtro = this._filterToShow.toLocaleLowerCase().trim();

    if (filtro.length > 0)
      filterdata = filterdata.filter(
        (f) =>
          (f.Nombre.toLocaleLowerCase() as string).indexOf(filtro) > -1 ||
          ((f.CURP ?? "").toLocaleLowerCase() as string).indexOf(filtro) > -1 ||
          ((f.Puesto ?? "").toLocaleLowerCase() as string).indexOf(filtro) > -1
      );
    this.filterListToSend = filterdata;
  }
  filterToPrint() {
    let filterdata = this.listToPrint;
    let filtro = this._filterToPrint.toLocaleLowerCase().trim();

    if (filtro.length > 0)
      filterdata = filterdata.filter(
        (f) =>
          (f.Nombre.toLocaleLowerCase() as string).indexOf(filtro) > -1 ||
          ((f.CURP ?? "").toLocaleLowerCase() as string).indexOf(filtro) > -1 ||
          ((f.Puesto ?? "").toLocaleLowerCase() as string).indexOf(filtro) > -1
      );
    this.filterListToPrint = filterdata;
  }

  addToPrint() {
    let newToPrint = [...this.idtosend, ...this.currentSelectionToAdd];
    this.idtosend = newToPrint;
    this.currentSelectionToAdd = [];
    this.changeRealData();
  }
  removeToPrint() {
    let newToPrint = this.idtosend.filter(
      (f) => this.currentSelectionToRemove.includes(f) == false
    );
    this.idtosend = newToPrint;
    this.currentSelectionToRemove = [];
    this.changeRealData();
  }
  changeRealData() {
    this.listToSend = this.realdata.filter(
      (f) => this.idtosend.includes(f.IdTrabajador) == false
    );
    this.listToPrint = this.realdata.filter(
      (f) => this.idtosend.includes(f.IdTrabajador) == true
    );
    this.filtersRun();
  }

  sendToPrint() {
    this.spinner.show();
    this.service.print(this.dateInit, this.dateEnd, this.idtosend).subscribe(
      (next) => {
        this.downLoadFile(next, 'application/pdf', "credenciales.pdf");
        this.spinner.hide();
        this.dateInit = null;
        this.dateEnd = null;
        this.currentSelectionToAdd = [];
        this.currentSelectionToRemove = [];
        this.loadRecords();
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Error al descargar");
      }
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }

  filtersRun() {
    this.filterdata();
    this.filterToPrint();
  }

  changeDateInit(e) {
    if (this.dateEnd == null) return;
    if (dayjs(e).isAfter(dayjs(this.dateEnd))) {
      this.dateEnd = null;
    }
  }
}
